import NotAuthorizedPage from './component';
export default NotAuthorizedPage;
